"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _identityActions = require("../actions/identity-actions");

var _httpActions = require("../actions/http-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  isFetching: false,
  overrideIsFetching: false,
  message: '',
  count: 0,
  cancelTokens: []
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _httpActions.HTTP_REQUEST, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: true,
    count: state.count + 1
  });
}), (0, _defineProperty2.default)(_handleActions, _httpActions.HTTP_OVERRIDE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: true,
    message: action.payload.message,
    count: state.count + 1
  });
}), (0, _defineProperty2.default)(_handleActions, _httpActions.HTTP_OVERRIDE_IS_FETCHING, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    overrideIsFetching: action.payload
  });
}), (0, _defineProperty2.default)(_handleActions, _httpActions.HTTP_COMPLETE, function (state) {
  var count = state.count - 1;
  var isFetching = count > 0;
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: isFetching,
    message: isFetching ? state.message : '',
    count: Math.max(count, 0) // in case of dumb developer

  });
}), (0, _defineProperty2.default)(_handleActions, _identityActions.RELOAD, function () {
  return _objectSpread({}, initialState);
}), (0, _defineProperty2.default)(_handleActions, _httpActions.HTTP_ADD_CANCEL, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    cancelTokens: [].concat((0, _toConsumableArray2.default)(state.cancelTokens), [action.payload])
  });
}), (0, _defineProperty2.default)(_handleActions, _httpActions.HTTP_CANCEL_ALL, function (state) {
  state.cancelTokens.forEach(function (c) {
    return c();
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    cancelTokens: []
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;